var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm.type === "credit-card"
      ? _c("i", { staticClass: "icn icn-credit-card" })
      : _vm._e(),
    _vm.type === "direct-debit"
      ? _c("img", {
          attrs: {
            src: require("@/assets/icons/direct-debit.svg"),
            width: "40",
            height: "40"
          }
        })
      : _vm._e(),
    _vm.type !== "direct-debit" && _vm.type !== "credit-card"
      ? _c("span", [_vm._v(_vm._s(_vm.type))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }